<script>
	import { postSettings, allowTrans, allowBlend, allowFilter } from "./stores.js";

	import ColorPicker from "./components/ColorPicker.svelte";
	import SegControl from "./components/SegControl.svelte";
	import FileInput from "./components/FileInput.svelte";
    import GradientPicker from "./components/GradientPicker.svelte";

	let alpha = 0;
	let lastOpac = 0;

	const colgrad = [
			{
				id: 1,
				val: false,
				label: "Color"
			},
			{
				id: 2,
				val: true,
				label: "Gradient"
			},
		];

	const blendlist = [
		{id: 1, val: "normal", label: "Normal"},
		{id: 2, val: "multiply", label: "Multiply"},
		{id: 3, val: "darken", label: "Darken"},
		{id: 4, val: "color-burn", label: "Color Burn"},
		{id: 5, val: "screen", label: "Screen"},
		{id: 6, val: "lighten", label: "Lighten"},
		{id: 7, val: "color-dodge", label: "Color Dodge"},
		{id: 8, val: "overlay", label: "Overlay"},
		{id: 9, val: "hard-light", label: "Hard Light"},
		{id: 10, val: "soft-light", label: "Soft Light"},
		{id: 11, val: "difference", label: "Difference"},
		{id: 12, val: "exclusion", label: "Exclusion"},
		{id: 13, val: "hue", label: "Hue"},
		{id: 14, val: "saturation", label: "Saturation"},
		{id: 15, val: "color", label: "Color"},
		{id: 16, val: "luminosity", label: "Luminosity"}
	];

	const filterlist = [
		{id: 1, val: "nofilter", label: "None"},
		{id: 2, val: "duotone", label: "Duotone"},
		{id: 3, val: "grayscale", label: "Grayscale"},
		{id: 4, val: "sepia", label: "Sepia"},
		{id: 5, val: "warmup", label: "Warm-Up"},
		{id: 6, val: "cooldown", label: "Cool-Down"},
		{id: 6, val: "hicontrast", label: "High Contrast"},
		{id: 6, val: "saturate", label: "Saturated"}
	];

	$: {
		$postSettings.alpha = alpha;
	}

	/* function rotateGrad() {
		if (alpha >= 360) {
			alpha -= 360;
		}

		alpha += 45;
	} */

	function swapColors() {
		let startNew = $postSettings.endCol;
		let endNew = $postSettings.startCol;

		[$postSettings.startCol, $postSettings.endCol] = [startNew, endNew]
	}

	function handleUpdate() {
		$allowFilter = true;

		if ($postSettings.filter == "duotone") {
			$allowTrans = false;
			$allowBlend = false;
		}	else {
			$allowTrans = true;
			$allowBlend = true;
		}

		if ($postSettings.opacity === 1) {
			$postSettings.opacity = 0;
		}
	}

	function handleClear() {
		$postSettings.opacity = 1;
		$postSettings.blending = "normal";
		$postSettings.filter = "nofilter";

		$allowTrans = false;
		$allowBlend = false;
		$allowFilter = false;
	}

	function handleBlend() {
		if ($postSettings.backdrop) {
			$allowTrans = true;
		} else {
			$postSettings.opacity = 1;
			$allowTrans = false;
		}
	}

	function handleFilter() {
		if ($postSettings.backdrop) {
			lastOpac = $postSettings.opacity;

			if ($postSettings.filter == "duotone") {
				$postSettings.opacity = 0;
				$allowTrans = false;
				$allowBlend = false;
			} else {
				$postSettings.opacity = (lastOpac == 1 ? 0 : lastOpac);
				$allowTrans = true;
				$allowBlend = true;
			}
		} else {
			lastOpac = 0;

			$postSettings.opacity = 1;
			$allowTrans = false;
		}
	}
</script>

<div class="panel--title">
	<h2>Post Background</h2>
</div>

<div class="panel--body">
	<h4>Background {$postSettings.filter == "duotone" ? "Duotone" : ""}</h4>

	{#if $postSettings.filter == "duotone"}
		<!-- duotone controls -->
		<div id="bg-duo">
			<!-- duotone highlights -->
			<div class="cell" id="bg-high">
				<label for="bg-high">Highlights</label>
				<ColorPicker bind:color={$postSettings.startCol} />
			</div>
			<!-- color swap -->
			<div class="cell" id="col-swap">
				<label for="col-swap">Swap</label>
				<button class="icon" on:click={swapColors}>
					<img src="img/swap.svg" alt="Swap Colors">
				</button>
			</div>
			<!-- duotone shadows -->
			<div class="cell" id="bg-shad">
				<label for="bg-shad">Shadows</label>
				<ColorPicker bind:color={$postSettings.endCol} />
			</div>
		</div>
	{:else}
		<SegControl items={colgrad} bind:group={$postSettings.isGrad} name='colgrad' />

		{#if $postSettings.isGrad}
			<!-- gradient controls -->
			<div id="bg-grad">
			    <label for="bg-grad">Gradient</label>
			    <GradientPicker
					bind:startCol={$postSettings.startCol}
					bind:endCol={$postSettings.endCol}
					bind:angle={alpha}
				/>

				<!--
				<div class="cell" id="bg-start">
					<label for="bg-start">Start</label>
					<ColorPicker bind:color={$postSettings.startCol} />
				</div>

				<div class="cell" id="col-swap">
					<label for="col-swap">Swap</label>
					<button class="icon" on:click={swapColors}>
						<img src="img/swap.svg" alt="Swap Colors">
					</button>
				</div>

				<div class="cell" id="bg-end">
					<label for="bg-end">End</label>
					<ColorPicker bind:color={$postSettings.endCol} />
				</div>

				<div class="cell" id="angle">
					<label for="angle">Angle</label>
					<button class="icon" on:click={rotateGrad}>
						<div class="indicator" style="background-image: linear-gradient({alpha}deg, transparent 50%, rgb(192, 192, 192))">
							&nbsp;
						</div>
						<img src="img/rotate-clockwise.svg" alt="Rotate Gradient">
					</button>
					<output>{alpha}</output>
				</div>
				-->

			</div>
		{:else}
			<div id="bg-col">
				<!-- single color controls -->
				<label for="bg-col">Color</label>
				<ColorPicker bind:color={$postSettings.startCol} />
			</div>
		{/if}
	{/if}

	<h4>Post Photo</h4>

	<FileInput bind:file={$postSettings.backdrop} on:update={handleUpdate} on:clear={handleClear} />

	<h4>Overlay Opacity</h4>

	<input type="range" name="opacity" bind:value={$postSettings.opacity} id="opacity" min="0" max="1" step="0.01" disabled="{!$allowTrans}">

	<h4>Overlay Blend Mode</h4>

	<select name="blend" id="blend" bind:value={$postSettings.blending} on:change={handleBlend} disabled="{!$allowBlend}">
		{#each blendlist as bl}
			<option value="{bl.val}">{bl.label}</option>
		{/each}
	</select>

	<h4>Photo Filter</h4>

	<select name="filter" id="filter" bind:value={$postSettings.filter} on:change={handleFilter} disabled="{!$allowFilter}">
		{#each filterlist as fl}
			<option value="{fl.val}">{fl.label}</option>
		{/each}
	</select>

</div>

<style lang="scss">

</style>
